import { render, staticRenderFns } from "./PasswordUpdate.vue?vue&type=template&id=8ee68e3a&"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js&"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports